import { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { ClickAwayListener } from '@material-ui/core'
import { environment } from '../../config.json'

import {
    Eye,
    Download,
    GripLines,
    Share,
    Pen,
    History,
    FileAlt,
    CloudUpload,
    Sync,
    FileDownload,
    Duplicate,
    RegisteredMail,
    Fave,
    EditNote,
    SwitchAccess,
    Draw,
    ValidationMode,
    Close
} from '../../assets/icons'
import {
    SingleDocumentVariables,
    SingleDocumentHistory,
    SingleDocumentSynthesis,
    SingleDocumentInject,
    SingleDocumentAttachments,
} from './'
import { CustomTooltip, Alert } from '../ui_new'
import { useAgencyActions, useSingleDocumentActions } from '../../hooks'
import { UserContext, LoaderContext, SingleDocumentContext, ValidationContext, NotificationContext } from '../../context'
import useWindowDimensions from '../../hooks/useWindowDimensions'
import { isMobile } from 'react-device-detect'
import { defaultAttachmentsForDocument } from '../../utils'
import { FEATURE, isFeatureEnabled } from '../../utils'
import { Replay, Star, SwitchAc } from '@material-ui/icons'
import SingleDocumentRenderSettings from './SingleDocumentRenderSettings'
import { AddCircleOutline, ArrowBack, CheckCircle, CheckCircleOutline, CloseOutlined, Delete, Edit, HighlightOff, Loop, MoreVert, PaletteOutlined, Redo, Save, SettingsOutlined, Undo } from '@mui/icons-material'
import { AttachmentsContext } from '../../context/attachments/attachmentsState'
import { VALIDATION_STATUS } from '../../constants'

const SingleDocumentMain = ({
    singleDoc,
    templateData,
    documentValues,
    onValuesChange,
    documentCheckboxValues,
    onCheckboxValueChange,
    useCustomCover,
    onAgencyModalOpen,
    onNotariesModalOpen,
    onSave,
    onDocumentPreview,
    linesAdded,
    attachments,
    onAttachmentShareUpdate,
    onAttachmentShareSave,
    documentId,
    documentName,
    template,
    activeDocContacts,
    onSetDocumentValues,
    docHistory,
    docEvents,
    onVersionRestore,
    onFetchHistory,
    onResetSetup,
    view,
    onSetView,
    onSetDocumentAttachments,
    onSetTab,
    onToggleSidePanel,
    isSidePanelOpen,
    isContentEditable,
    onToggleContentEditable,
    onSectionContentChanged,
    onUndoContentChanges,
    onRedoContentChanges,
    canUndoContentChanges = false,
    canRedoContentChanges = false,
    onDocumentDownload,
    templateMetaSections,
    previewSettings,
    onPreviewRefresh,
    onRenderSettingsSave,
    progress,
    onCreateStandardTemplate,
    onNavigateToEmptyVariable,
    renderOptions,
    shareAttachments,
    onShare,
    onSign,
    onLRE,
}) => {
    const { moveDocumentToDeleteDocuments, duplicateDocument, downloadDocumentData, immocloudUploadAvailable, uploadToCloud } = useSingleDocumentActions()
    const { isTemplateValidationRequired } = useAgencyActions()
    const { immocloudConfig, hideActionBar, agency, user, integration, userClaims } = useContext(UserContext)
    const { setShowGlobalResponseLoader, setGlobalResponseLoaderText } = useContext(LoaderContext)
    const { defaultAttachments, setPrefilledAttachmentVariable } = useContext(AttachmentsContext)
    const { enableValidationMode, disableValidationMode, revisionModeEnabled, openValidationModal, openValidationModeSummary, activeValidation, publicView } = useContext(SingleDocumentContext)
    const { promptResolveValidation, showValidationWarning, closeValidationWarning } = useContext(ValidationContext)
    const { setNotification } = useContext(NotificationContext)

    // const [showShareModal, setShowShareModal] = useState(false)
    const [showRenderSettingsModal, setShowRenderSettingsModal] = useState(false)
    const [showHistoryModal, setShowHistoryModal] = useState(false)
    const [showSynthesisModal, setShowSynthesisModal] = useState(false)
    const [showInjectModal, setShowInjectModal] = useState(false)
    const [showDeleteAlert, setShowDeleteAlert] = useState(false)
    const [showDocxDownloadAlert, setShowDocxDownloadAlert] = useState(false)
    const [showMoreActions, setShowMoreActions] = useState(false)
    const history = useHistory()

    // On document save
    const handleSave = () => {
        onSave()
    }

    // On document preview
    const handleDocumentPreview = () => {
        if (!onDocumentPreview) return
        onDocumentPreview()
    }

    const agencyFontConfig = () => {
        if (!agency) {
            return {}
        }
        const font_config = {
            heading_2: {
                color: agency.cover_color,
                borderColor: agency.cover_color,
            },
            heading_3: {
                color: "#ffffff",
                backgroundColor: agency.cover_color,
            },
            footer_title: {
                color: agency.cover_color,
            },
            cover_title: {
                color: agency.cover_color,
            }
        }
        return font_config
    }

    const agencyConfig = () => {
        if (!agency) {
            return {}
        }
        const config = {
            cover_color: agency.cover_color,
        }
        return config
    }

    // On pdf download
    const handlePdfDownload = () => {
        onDocumentDownload('pdf')
    }

    // On open docx download alert
    const handleOpenDocxDownloadAlert = () => {
        setShowDocxDownloadAlert(true)
    }

    // On close docx download alert
    const handleCloseDocxDownloadAlert = () => {
        setShowDocxDownloadAlert(false)
    }

    // // On docx download
    const handleDocxDownload = () => {
        onDocumentDownload('docx')
        setShowDocxDownloadAlert(false)
    }

    // On open history modal
    const handleOpenHistoryModal = () => {
        onFetchHistory()
        setShowHistoryModal(true)
    }

    // On close history modal
    const handleCloseHistoryModal = () => {
        setShowHistoryModal(false)
    }

    // On open synthesis modal
    const handleOpenSynthesisModal = async () => {
        setShowSynthesisModal(true)
    }

    // On close synthesis modal
    const handleCloseSynthesisModal = () => {
        setShowSynthesisModal(false)
    }

    // On open inject modal
    const handleOpenInjectModal = () => {
        setShowInjectModal(true)
    }

    // On close inject modal
    const handleCloseInjectModal = () => {
        setShowInjectModal(false)
    }

    // On open delete alert
    const handleOpenDeleteAlert = () => {
        setShowDeleteAlert(true)
    }

    // On close delete alert
    const handleCloseDeleteAlert = () => {
        setShowDeleteAlert(false)
    }

    // On delete document
    const handleDeleteDocument = async () => {
        setShowGlobalResponseLoader(true)
        try {
            await moveDocumentToDeleteDocuments({
                ...singleDoc,
                id: documentId,
            })
            history.push('/documents')
        } catch (err) {
        } finally {
            setShowGlobalResponseLoader(false)
        }
    }

    // On duplicate
    const handleDuplicate = async () => {
        setShowGlobalResponseLoader(true)
        try {
            const id = await duplicateDocument({
                doc: singleDoc,
                template,
            })
            history.replace(`/documents/${id}`)
            onResetSetup()
        } catch (err) {
            console.log(err)
        } finally {
            setShowGlobalResponseLoader(false)
        }
    }

    // On data download
    const handleDownloadData = () => {
        downloadDocumentData({
            documentValues,
            documentCheckboxValues,
            documentName,
            documentId,
        })
    }

    // On upload to upload
    const handleCloudUpload = async () => {
        setShowGlobalResponseLoader(true)
        try {
            await uploadToCloud({
                template,
                doc: singleDoc,
                immocloudConfig,
            })
        } catch (err) {
            console.log(err)
        } finally {
            setShowGlobalResponseLoader(false)
        }
    }

    // On more actions click away
    const handleMoreActionsClickAway = () => {
        setShowMoreActions(false)
    }

    // On toggle more actions
    const handleToggleMoreActions = () => {
        setShowMoreActions(!showMoreActions)
    }

    const handleUndo = () => {
        if (onUndoContentChanges) {
            onUndoContentChanges()
        }
    }

    const handleRedo = () => {
        if (onRedoContentChanges) {
            onRedoContentChanges()
        }
    }

    const handleEnableValidationMode = () => {
        
        handleMoreActionsClickAway()

        if(!activeValidation) {
            setNotification({ msg: "Aucune validation active pour ce document.", type: "warning" })
            return
        }

        enableValidationMode()
    }

    const MoreActionsButton = ({ label }) => {
        return (
            <ClickAwayListener onClickAway={handleMoreActionsClickAway}>
                <div className="document-main__actions_more">
                    <button
                        className="button action-btn small-icon"
                        onClick={handleToggleMoreActions}
                    >
                        <span>
                            <MoreVert />
                            { label }
                        </span>
                    </button>
                    {showMoreActions && (
                        <div className="more-dropdown">
                            <ul>
                                <li className="">
                                    <button className="btn-hover">
                                        <span className="icon"><Download /></span>
                                        <span className="text">
                                            Télécharger
                                        </span>
                                        <div className="icon-btn__popover">
                                            <button onClick={handlePdfDownload}>pdf</button>
                                            <button onClick={handleOpenDocxDownloadAlert}>
                                                docx
                                            </button>
                                        </div>
                                    </button>
                                </li>
                            </ul>
                            <ul>
                                <li className="">
                                    {immocloudUploadAvailable() &&
                                        <button onClick={handleCloudUpload}>
                                            <span className="icon"><CloudUpload /></span> {
                                                "Envoyer vers Immocloud"
                                                // immocloudConfig.handle === 'customer_id'
                                                //     ? "Envoyer vers l'Immocloud du contact"
                                                //     : "Envoyer vers l'Immocloud du bien"
                                            }
                                        </button>
                                    }
                                </li>
                                <li className="">
                                    <button onClick={() => {
                                        onShare()
                                        handleMoreActionsClickAway()
                                    }}>
                                        <span className="icon"><Share /></span>
                                        <span className="text">
                                            Partager
                                        </span>
                                    </button>
                                </li>
                                <li>
                                    <button
                                        onClick={
                                            handleOpenSynthesisModal
                                        }
                                    >
                                        <span className="icon"><FileAlt /></span>{' '}
                                        <span className="text">
                                            Synthèse
                                        </span>
                                    </button>
                                </li>
                                <li>
                                    <button
                                        onClick={handleOpenHistoryModal}
                                    >
                                        <span className="icon"><History /></span>{' '}
                                        <span className="text">
                                            Historique
                                        </span>
                                    </button>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <button
                                        onClick={() => {
                                            onSign()
                                            handleMoreActionsClickAway()
                                        }}
                                    >
                                        <span className="icon"><Draw /></span> Signer
                                    </button>
                                </li>
                                <li>
                                    {isFeatureEnabled(FEATURE.AR24, integration) &&
                                        <button onClick={() => {
                                            onLRE()
                                            handleMoreActionsClickAway()
                                        }}>
                                            <span className="icon"><RegisteredMail /></span>
                                            Envoyer par LRE
                                        </button>
                                    }
                                </li>
                            </ul>
                            <ul>

                                <li>
                                    <button
                                        onClick={handleDownloadData}
                                    >
                                        <span className="icon"><FileDownload /></span>{' '}
                                        <span className="text">
                                            Télécharger les données
                                        </span>
                                    </button>
                                </li>
                                <li>
                                    <button
                                        onClick={handleOpenInjectModal}
                                    >
                                        <span className="icon"><Loop /></span>{' '}
                                        <span className="text">
                                            Injecter
                                        </span>
                                    </button>
                                </li>
                            </ul>

                            {isFeatureEnabled(FEATURE.DOCUMENT_VALIDATION, integration) &&
                                <ul>
                                    <li>
                                        <button
                                            onClick={handleEnableValidationMode}
                                            disabled={revisionModeEnabled || !activeValidation || (activeValidation && activeValidation.status === 'refused')}
                                        >
                                            <span className="icon"><ValidationMode /></span>
                                            Mode révision
                                        </button>
                                    </li>
                                    {activeValidation && activeValidation.status === 'pending' && user.validation_access === 'manager' && activeValidation.validators.some(validator => validator.id === `${user.id}`) && <>
                                        <li className='success'>
                                            <button
                                                onClick={() => promptResolveValidation(activeValidation, 'validate')}
                                            >
                                                <span className="icon"><CheckCircleOutline /></span>
                                                <span className='text'>Valider le document</span>
                                            </button>
                                        </li>
                                        <li className='trash'>                                   
                                            <button 
                                                onClick={() => promptResolveValidation(activeValidation, 'refuse')}>
                                                <span className="icon"><HighlightOff /></span>
                                                <span className='text'>Refuser le document</span>
                                            </button>
                                        </li>
                                    </>}
                            </ul>}

                            <ul>
                                {isFeatureEnabled(FEATURE.STANDARD_TEMPLATES, integration) && isFeatureEnabled(FEATURE.STANDARD_TEMPLATE_CREATE, integration) && <li>
                                    <button
                                        onClick={onCreateStandardTemplate}
                                    >
                                        <span className="icon"><Fave /></span>{' '}
                                        <span className="text">
                                            Créer un modèle type
                                        </span>
                                    </button>
                                </li>}

                                <li className='duplicate'>
                                    <button onClick={handleDuplicate}>
                                        <span className="icon"><Duplicate /></span>{' '}
                                        <span className="text">
                                            Dupliquer
                                        </span>
                                    </button>
                                </li>
                                <li className='trash'>
                                    <button
                                        onClick={handleOpenDeleteAlert}
                                    >
                                        <span className="icon"><Delete /></span>{' '}
                                        <span className="text">
                                            Supprimer
                                        </span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </ClickAwayListener>
        )
    }

    return (
        <>
            {view !== 'attachments' && !publicView && <div
                className="document-main__actions"
                style={{
                    display: isMobile ? (hideActionBar ? 'none' : '') : '',
                }}
            >
                {!revisionModeEnabled && isContentEditable && <div className="document-main__editor-toolbar mr-2">
                    <CustomTooltip content="Annuler">
                        <div className=''>
                            <button
                                className="icon-btn icon-btn--sm"
                                onClick={handleUndo}
                                disabled={!canUndoContentChanges}
                            >
                                <Undo fontSize='small' />
                            </button>
                        </div>
                    </CustomTooltip>
                    <CustomTooltip content="Rétablir">
                        <button
                            className="icon-btn icon-btn--sm"
                            onClick={handleRedo}
                            disabled={!canRedoContentChanges}
                        >
                            <Redo fontSize='small' />
                        </button>
                    </CustomTooltip>
                </div>}
                {!revisionModeEnabled && <button
                    className="button height-40 button--outline-primary button--with-icon btn-text button--hover-light-pink mr-2"
                    onClick={() => setShowRenderSettingsModal(true)}
                >
                    <PaletteOutlined fontSize="small" /><span className=''> Mise en page</span>
                </button>}
                {!revisionModeEnabled && isFeatureEnabled(FEATURE.EDITABLE_CONTENT_LITE, integration) && <button
                    className={`button rounded-sm btn-text button--with-icon ${isContentEditable ? 'button--outline-success' : 'button--outline-danger'}`}
                    onClick={onToggleContentEditable}
                >
                    <EditNote /><span className=''>{isContentEditable ? 'Edition activée' : 'Edition désactivée'}</span>
                </button>}
                {!revisionModeEnabled && <div className='flex ml-auto items-center right-buttons flex-wrap'>
                    <button
                        className="button button--with-icon button--outline-primary-light rounded-sm btn-text"
                        onClick={handleDocumentPreview}
                    >
                        <Eye /> <span className=''>Aperçu</span>
                    </button>
                    <button
                        className="button height-40 button--with-icon btn-text"
                        onClick={handleSave}
                    >
                        <CheckCircle fontSize="small" /> <span className='btn-text'>Sauvegarder</span>
                    </button>
                    <MoreActionsButton label="Action" />
                </div>}
                {revisionModeEnabled && 
                    ((activeValidation && activeValidation.status !== 'validated' && activeValidation.validators.some(validator => validator.id === `${user.id}`)) ? (
                        <div className="flex items-center flex-wrap justify-between gap-2 w-full">
                            <button
                                className="icon-btn icon-btn--xl"
                                onClick={() => {
                                    disableValidationMode()
                                }}
                            >
                                <ArrowBack fontSize='medium' />
                            </button>
                            <div className='flex flex-row items-center items-center gap-2 flex-wrap'>
                                {activeValidation && activeValidation.status === 'pending' && user.validation_access === 'manager' && 
                                <div className='flex gap-2 validation-controlls'>
                                    <button
                                        className="button btn--danger btn--with-icon btn--large"
                                        onClick={() => promptResolveValidation(activeValidation, 'refuse')}
                                    >
                                        <span>
                                            <Close />
                                        </span>
                                        Refuser
                                    </button>
                                    <button
                                        className="button btn--success btn--with-icon btn--large"
                                        onClick={() => promptResolveValidation(activeValidation, 'validate')}
                                    >
                                        <span>
                                            <CheckCircle />
                                        </span>
                                        Valider
                                    </button>
                                </div>}
                                <MoreActionsButton label="Outils" />
                            </div>
                        </div>
                    ) : (
                        <div className='flex ml-auto items-center right-buttons flex-wrap'>
                            <button
                                className="button height-40 button--with-icon btn-text"
                                onClick={() => {
                                    disableValidationMode()
                                }}
                            >
                                <Edit fontSize="small" /> <span className='btn-text'>Éditer le document</span>
                            </button>
                            <MoreActionsButton label="Outils" />
                </div>))}
            </div>}
            {view === 'attachments' && <div
                className="document-main__actions"
                style={{
                    display: isMobile ? (hideActionBar ? 'none' : '') : '',
                }}
            >
                <div className='flex ml-auto items-center right-buttons flex-wrap'>
                    <button
                        // className='btn btn--with-icon btn--small btn--light btn--border-primary btn--border-radius-sm'
                        className='button button--with-icon button--outline-primary-light rounded-sm btn-text'

                        onClick={() => {
                            if(!isSidePanelOpen)
                                onToggleSidePanel()
                                setPrefilledAttachmentVariable(null)
                            
                        }}>
                            <AddCircleOutline fontSize='small' />
                            Ajouter des pièces jointes
                        </button>
                    <button
                        className="button height-40 button--with-icon btn-text"
                        onClick={handleSave}
                    >
                        <Save fontSize="small" /> <span className='btn-text'>Sauvegarder</span>
                    </button>

                </div>
            </div>}

            <div className={`document-main__body ${view === 'attachments' ? 'document-main__body--attachments' : ''}`}>
                {view === 'variables' && (
                    <SingleDocumentVariables
                        templateData={templateData}
                        documentValues={documentValues}
                        onValuesChange={onValuesChange}
                        documentCheckboxValues={documentCheckboxValues}
                        onCheckboxValueChange={onCheckboxValueChange}
                        useCustomCover={useCustomCover}
                        onAgencyModalOpen={onAgencyModalOpen}
                        onNotariesModalOpen={onNotariesModalOpen}
                        isContentEditable={isContentEditable}
                        onSectionContentChanged={onSectionContentChanged}
                        templateMetaSections={templateMetaSections}
                        linesAdded={linesAdded}
                        attachments={attachments}
                        onSetDocumentAttachments={onSetDocumentAttachments}
                        defaultAttachments={defaultAttachmentsForDocument(defaultAttachments, templateData, documentValues)}
                        docId={documentId}
                    />
                )}
                {view === 'attachments' && (
                    <SingleDocumentAttachments
                        attachments={attachments}
                        docId={documentId}
                        singleDoc={{...singleDoc, values: documentValues}}
                        template={templateData}
                        onSetDocumentAttachments={onSetDocumentAttachments}
                        onSetView={onSetView}
                        onSetTab={onSetTab}
                        onToggleSidePanel={onToggleSidePanel}
                        isSidePanelOpen={isSidePanelOpen}
                    />
                )}
            </div>

            {showRenderSettingsModal && (
                <SingleDocumentRenderSettings
                    onClose={() => setShowRenderSettingsModal(false)}
                    previewSettings={previewSettings}
                    onPreviewRefresh={onPreviewRefresh}
                    linesAdded={linesAdded}
                    useCustomCover={useCustomCover}
                    templateData={templateData}
                    onSave={onRenderSettingsSave}
                />
            )}

            {showHistoryModal && (
                <SingleDocumentHistory
                    onClose={handleCloseHistoryModal}
                    docHistory={docHistory}
                    docEvents={docEvents}
                    onRestore={onVersionRestore}
                />
            )}

            {showSynthesisModal && (
                <SingleDocumentSynthesis
                    onClose={handleCloseSynthesisModal}
                    documentValues={documentValues}
                    onSetDocumentValues={onSetDocumentValues}
                    data={template}
                />
            )}

            {showInjectModal && (
                <SingleDocumentInject
                    onClose={handleCloseInjectModal}
                    template={template}
                    doc={{
                        ...singleDoc,
                        name: documentName,
                        values: documentValues,
                        custom_cover: useCustomCover,
                        id: documentId,
                    }}
                    documentValues={documentValues}
                />
            )}

            {showDeleteAlert && (
                <Alert
                    onClose={handleCloseDeleteAlert}
                    text="Êtes-vous sûr de vouloir supprimer ce document ?"
                    onSubmit={handleDeleteDocument}
                    deleteAlert={true}
                />
            )}

            {showDocxDownloadAlert && (
                <Alert
                    onClose={handleCloseDocxDownloadAlert}
                    onOkClose={handleDocxDownload}
                    text="Note importante"
                    bodyText="Immo Docs ne pourra être tenu pour responsable des modifications apportées au .docx"
                    showOk
                    okBtnText="Télécharger le .docx"
                />
            )}
        </>
    )
}

export default SingleDocumentMain
